<template>
  <div class="pagination">
    <pagination :total="total" :current-page='current' @pagechange="pagechange"></pagination>
  </div>

</template>

<script>
/* eslint-disable */
import pagination from '@/components/pagination'
export default {
  components: {
    pagination
  },
  data() {
    return {
      total: 150,     // 记录总条数
      display: 10,   // 每页显示条数
      current: 1,   // 当前的页数
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">

// .treeWrap{
//   width: 300px;
//   height: 500px;
//   background: #999;
// }
// .item {
//   cursor: pointer;
// }
// .bold {
//   font-weight: bold;
// }
// ul {
//   padding-left: 1em;
//   line-height: 1.5em;
//   list-style-type: dot;
// }
</style>



// WEBPACK FOOTER //
// chat.vue?546eefc8